import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanCardBrand',
})
export class CleanCardBrandPipe implements PipeTransform {
  constructor() {}

  transform(brandName: string): string {
    const name: string = !!brandName ? brandName.replace(/_/g, ' ').toLowerCase() : '';
    return name;
  }
}
